<template>
    <b-row class="rows borders">
        <b-col
            id="leftBorder"
            :name="'quoteProduct_' + quoteProduct.transportProductId"
        >
            {{
            $t('createShipment.quote.product' + quoteProduct.transportProduct)
            }}
        </b-col>

        <b-col
            :name="'quoteTransportProduct_' + quoteProduct.transportProductId"
        >
            {{
            $t('createShipment.quote.transportProduct' + quoteProduct.transportProduct)
            }}
        </b-col>
        <b-col>{{ quoteProduct.billableWeight }}</b-col>

        <b-col cols="2" class="price-accordion">
            <div class="text-left quoteOptions ml-3">
                <b-form-radio-group
                    id="radio-slots"
                    :name="'quoteSalesProducts_' + quoteProduct.transportProductId"
                    v-model="selected"
                    stacked
                    plain
                    class="quote-radios"
                >
                    <b-form-radio
                        v-bind:key="item.translationKey"
                        v-for="item in quoteProduct.selections"
                        :value="item.translationKey"
                    >{{ $t('createShipment.quote.' + item.translationKey) }}</b-form-radio>

                    <b-form-radio
                        v-if="quoteProduct.selections.length > 1"
                        value="both"
                        :name="'quoteSelection_' + quoteProduct.transportProductId + '_0'"
                    >{{ $t('createShipment.quote.salesProductBoth', bothParams) }}</b-form-radio>
                </b-form-radio-group>
            </div>
        </b-col>
        <b-col cols="2">
            <div class="text-left quoteOptions">
                <!--Removed until matrices are ready for Express-->
                <!-- <b-form-checkbox
                    v-bind:key="item.productService"
                    v-for="item in quoteProduct.services"
                    v-model="item.selected"
                    :name="'quoteOptions_' + quoteProduct.transportProductId"
                    plain
                    >{{ $t('createShipment.quote.' + item.translationKey) }}</b-form-checkbox
                >-->
            </div>
        </b-col>

        <b-col class="price-accordion">
            <span class="ml-2">N/A</span>
        </b-col>
        <b-col v-if="display(fieldNames.TRANSIT_TIME)">
            <font-awesome-icon
                icon="spinner"
                size="lg"
                spin
                v-if="quoteProduct.estimatedTransitTime === null"
            />
            <span v-else>{{ quoteProduct.estimatedTransitTime }}</span>
        </b-col>
        <b-col>
            <b-button
                :disabled="quoteProduct.quoteRequested"
                size="sm"
                @click="displayRequestQuote"
                :name="'createQuoteButton_' + quoteProduct.transportProductId"
            >{{ requestQuoteButtonText }}</b-button>
        </b-col>
    </b-row>
</template>

<script>
  import localization from '../mixins/localizationMixin';
  import i18n from '../i18n';
  import requestQuoteModal from './requestQuoteModal';
  import { mapState, mapGetters } from 'vuex';
  import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
  import tagManager from '../gtmEventHandler.js';
  import { FIELD_NAMES } from '../store/nameConstants';
  import viewOptions from '../mixins/viewOptionsMixin';
  export default {
      components: { requestQuoteModal },
      mixins: [localization],
      props: {
          quoteProduct: { required: true },
          shippingOptions: { type: Object, required: true },
      },
      mixins: [viewOptions],
      data() {
          let selection = this.quoteProduct.selections[0].translationKey;
          if (this.quoteProduct.selections.length > 1) selection = 'both';

          return {
              selected: selection,
              fieldNames: FIELD_NAMES,
          };
      },
      methods: {
          displayRequestQuote() {
              const selection = this.selected;

              this.quoteProduct.selections.forEach((element) => {
                  element.selected = false;
                  if (element.translationKey == selection || selection == 'both')
                      element.selected = true;
              });

              this.$emit('display-request-quote', {
                  quoteProduct: this.quoteProduct,
                  selected: this.selected,
              });
          },
      },
      computed: {
          bothParams() {
              if (this.quoteProduct.selections.length > 1) {
                  return {
                      first: i18n.t(
                          'createShipment.quote.' + this.quoteProduct.selections[0].translationKey
                      ),
                      second: i18n.t(
                          'createShipment.quote.' + this.quoteProduct.selections[1].translationKey
                      ),
                  };
              }
              return {
                  first: i18n.t(
                      'createShipment.quote.' + this.quoteProduct.selections[0].translationKey
                  ),
                  second: i18n.t(
                      'createShipment.quote.' + this.quoteProduct.selections[0].translationKey
                  ),
              };
          },
          requestQuoteButtonText() {
              if (!this.quoteProduct.quoteRequested) {
                  return i18n.t('createShipment.button.requestQuote');
              }

              return i18n.t('createShipment.button.quoteRequested');
          },
      },
  };
</script>

<style>
  .quoteOptions {
      display: inline-block;
      padding: 0px !important;
  }

  .quoteOptions div input {
      margin-top: 0.15rem;
  }

  .quote-radios {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
  }

  .quote-radios div {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
  }
</style>
